export default __webpack_public_path__ + "d34776e4bbe53d4b8a054cff7369ed53.png";